import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { contentSpacingStyles, gridGapStyles } from "@store/theme/common/mixins";
import { FORM, TYPOGRAPHY } from "@store/theme/design";
import parseNumber from "@store/utilities/parseNumber";
import updateCssValue, { Operators } from "@store/utilities/updateCssValue";
import { css } from "styled-components";

export const formFieldSpacingStyles = () => css`
    ${contentSpacingStyles(null, FORM.field.spacing)}
`;

export const formButtonSpacingStyles = () => css`
    ${contentSpacingStyles(FORM.button.spacing, null)}
`;

export const formGridProps: GridContainerProps = {
    gap: 0,
    css: css`
        ${gridGapStyles(["30px"], [FORM.field.spacing])}
    `,
};

export const formNarrowGridProps: GridContainerProps = {
    gap: 0,
    css: css`
        ${gridGapStyles([FORM.field.spacing])}
    `,
};

export const buttonSpacingForGridItem = updateCssValue(
    FORM.button.spacing,
    Operators.Substract,
    (parseNumber(FORM.field.spacing) ?? 0) / 2,
);

export const formButtonGridItemProps: GridItemProps = {
    width: 12,
    css: css`
        padding-top: ${buttonSpacingForGridItem} !important; /* Required to override grid padding */
    `,
};

export const formFieldSizeVariants = {
    default: {
        borderRadius: 4,
        height: 48,
        fontSize: parseNumber(TYPOGRAPHY.size.base),
        icon: 18,
        iconPadding: 15,
        descriptionLineSpacing: 5,
    },
    small: {
        borderRadius: 3,
        height: 40,
        fontSize: parseNumber(TYPOGRAPHY.size.smaller),
        icon: 16,
        iconPadding: 12,
        descriptionLineSpacing: 5,
    },
};

export const formFieldBorderTypes = {
    error: {
        width: 2,
        borderPaddingRule: "",
        textAreaBorderPaddingRule: "",
    },
    focus: {
        width: 2,
        borderPaddingRule: "",
        textAreaBorderPaddingRule: "",
    },
    inactive: {
        width: 2,
        borderPaddingRule: `padding: 0 ${FORM.field.padding};`,
        textAreaBorderPaddingRule: `padding: ${FORM.field.padding};`,
    },
};
